module.exports = "<span class=\"placeholder\"></span>\n"